import { render } from "./OneSubEngine.vue?vue&type=template&id=1e5ed824&scoped=true"
import script from "./OneSubEngine.vue?vue&type=script&lang=js"
export * from "./OneSubEngine.vue?vue&type=script&lang=js"

import "./OneSubEngine.vue?vue&type=style&index=0&id=1e5ed824&lang=scss&scoped=true"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5ed824"]])

export default __exports__